export const TOKEN_GENERATION_KEY = process.env.REACT_APP_TOKEN_GENERATION_KEY
export const GLOBAL_DOMAIN = process.env.REACT_APP_API_URL
export const ASSET_BASE_URL = process.env.REACT_APP_ASSET_BASE_URL //"https://dbraeiassetmanagement.blob.core.windows.net/"
export const ASSET_CONTAINER = process.env.REACT_APP_ASSET_CONTAINER //"dbraei-dev"
export const DBRAIMT_ASSET_FOLDER = process.env.REACT_APP_ASSET_FOLDER // "dbraimt"
export const COMMON_ASSET_FOLDER = process.env.REACT_APP_COMMON_ASSET_FOLDER // "common"
export const IMAGE_BASE_PATH_DBRAIMT = ASSET_BASE_URL + ASSET_CONTAINER + '/' //+ DBRAIMT_ASSET_FOLDER + "/"; //"https://dbraeiassetmanagement.blob.core.windows.net/dbraei-dev/"
export const IMAGE_BASE_PATH_COMMON =
  ASSET_BASE_URL +
  ASSET_CONTAINER +
  '/' +
  DBRAIMT_ASSET_FOLDER +
  '/' +
  COMMON_ASSET_FOLDER +
  '/' // "https://dbraeiassetmanagement.blob.core.windows.net/dbraei-dev/dbraimt/common/"
export const ASSET_API_CONTAINER = process.env.REACT_APP_API_CONTAINER // "dbradcdev/"
export const ORGANIZATION_ID = process.env.REACT_APP_ORGANIZATION_ID // "10"
export const SUB_ORGANIZATION_ID = process.env.REACT_APP_SUB_ORGANIZATION_ID // "22"
export const ACTIVITY_ID = process.env.REACT_APP_ACTIVITY_ID // "18"
